import type { ComponentSchema, FieldSchema } from '../../../../../schema-types'
import { schema as shared } from '../../../../lightings/lightings-1/sections/footer/footer.schema'

const SOCIAL_PLATFORMS = ['facebook', 'instagram', 'youtube', 'tiktok', 'linkedin', 'x']
  .map(value => ({ label: value === 'x' ? 'X' : value[0]!.toUpperCase() + value.slice(1), value }))

/** The blue newsletter band above the footer. */
const NEWSLETTER_FIELDS: FieldSchema[] = [
  { key: 'newsletterTitle', label: 'Newsletter title', type: 'localized-string', default: 'Sign up to our newsletter' },
  { key: 'newsletterText', label: 'Newsletter offer line', type: 'localized-string', default: '…and get offers before anyone else' },
  {
    key: 'newsletterAction',
    label: 'Sign-up form link',
    type: 'string',
    placeholder: 'https://…',
    help: 'The email field posts to this form (e.g. your mailing-list sign-up form). Empty = a "Get offers on WhatsApp" button.',
  },
]

/**
 * Torongo footer: the shared footer fields (stored data stays portable) with the platforms its icons
 * support, plus the newsletter band. Phone, email and address fall back to Store info.
 */
export const schema: ComponentSchema = {
  ...shared,
  label: 'Footer',
  description: 'Newsletter band, brand column with hotline and shop address, link columns and payment badges.',
  variants: [{ id: 'v1', label: 'Light grey with a blue newsletter band' }],
  commonFields: [
    ...NEWSLETTER_FIELDS,
    ...shared.commonFields
      .filter(f => f.key !== 'title')
      .map((f): FieldSchema => (f.key !== 'socialLinks'
        ? f
        : { ...f, itemSchema: f.itemSchema?.map(i => (i.key === 'platform' ? { ...i, options: SOCIAL_PLATFORMS } : i)) })),
  ],
}
